import { Tabs } from 'antd';
import css from './uiboarddetails.module.scss';
import {
    OtherProductModule,
    MultiSellPointsModule,
    SwitchTabModule,
    TextModule,
    CardModule,
    BannerModule,
    TextWithImage,
    VideoModule,
    TextOnImage,
    CardSliderModule,
    SwiperBanner,
} from '@/components/ProductDetailComponents';

import PageLayout from '@/components/PageLayout';
import { LineSpace } from '@/components/ProductComponents';

export default function uiboarddetails() {
    const { TabPane } = Tabs;
    const banneritem2 = [
        {
            bgImgs: '/test/banner1.png',
            title: 'DELTA',
            suffix: ' PRO',
            des: 'Live without limits with the portable home battery',
        },
    ];
    const banneritem3 = [
        {
            bgImgs: '/test/banner2.png',
            title: 'DELTA',
            suffix: ' PRO',
            des: 'Live without limits',
        },
    ];
    const banneritem4 = [
        {
            bgImgs: '/test/banner3.png',
            title: 'DELTA',
            suffix: ' PRO',
            des: 'Live without limits',
        },
    ];
    const banneritem5 = [
        {
            bgImgs: '/test/banner1.png',
            title: 'DELTA',
            suffix: ' PRO',
            des: 'Live without limits with the portable home battery',
        },
    ];
    const banneritem6 = [
        {
            bgImgs: '/test/banner2.png',
            title: 'DELTA',
            suffix: ' PRO',
            des: 'Live without limits',
        },
    ];
    const banneritem7 = [
        {
            bgImgs: '/test/banner3.png',
            title: 'DELTA',
            suffix: ' PRO',
            des: 'Live without limits',
        },
    ];
    const banneritem8 = [
        {
            bgImgs: '/test/banner4.png',
            title: 'DELTA',
            suffix: ' PRO',
            des: 'Live without limits with the portable home battery',
        },
    ];
    const banneritem9 = [
        {
            bgImgs: '/test/banner5.png',
            title: 'DELTA',
            suffix: ' PRO',
            des: 'Live without limits',
        },
    ];
    const banneritem10 = [
        {
            bgImgs: '/test/banner6.png',
            title: 'DELTA',
            suffix: ' PRO',
            des: 'Live without limits',
        },
    ];
    const banneritem11 = [
        {
            bgImgs: '/test/banner4.png',
            title: 'DELTA',
            suffix: ' PRO',
            des: 'Live without limits with the portable home battery',
        },
    ];
    const banneritem12 = [
        {
            bgImgs: '/test/banner5.png',
            title: 'DELTA',
            suffix: ' PRO',
            des: 'Live without limits',
        },
    ];
    const banneritem13 = [
        {
            bgImgs: '/test/banner6.png',
            title: 'DELTA',
            suffix: ' PRO',
            des: 'Live without limits',
        },
    ];
    const TextOnItem1 = {
        title: 'Interior / Exterior Design',
        synopsis: 'Power pretty much anything',
        desc: 'Keep your home comforts running during a blackout. AC units, kitchen appliances and power tools are all accessible with DELTA Pro. Use a single unit to power up to 4500W¹ of appliances. Need even more power? ',
        bgImgs: '/test/sImage1.png',
    };
    const TextOnItem2 = {
        title: 'Interior / Exterior Design',
        synopsis: 'Power pretty much anything',
        desc: 'Keep your home comforts running during a blackout. AC units, kitchen appliances and power tools are all accessible with DELTA Pro. Use a single unit to power up to 4500W¹ of appliances. Need even more power? ',
        bgImgs: '/test/sImage2.png',
    };
    const textWithImgItem1 = {
        title: 'Interior / Exterior Design',
        synopsis: 'Power pretty much anything',
        desc: 'Keep your home comforts running during a blackout. AC units, kitchen appliances and power tools are all accessible with DELTA Pro. Use a single unit to power up to 4500W¹ of appliances. Need even more power? ',
        img_url: '/test/sImage3.png',
    };
    const textWithImgItem2 = {
        title: 'Interior / Exterior Design',
        synopsis: 'Power pretty much anything',
        desc: 'Keep your home comforts running during a blackout. AC units, kitchen appliances and power tools are all accessible with DELTA Pro. Use a single unit to power up to 4500W¹ of appliances. Need even more power? ',
        img_url: '/test/sImage3.png',
    };
    const TextOnItem3 = {
        title: 'Interior / Exterior Design',
        synopsis: 'Power pretty much anything',
        desc: 'Keep your home comforts running during a blackout. AC units, kitchen appliances and power tools are all accessible with DELTA Pro. Use a single unit to power up to 4500W¹ of appliances.',
        bgImgs: '/test/sImage4.png',
    };
    const TextOnItem4 = {
        title: 'Interior / Exterior Design',
        synopsis: 'Power pretty much anything',
        desc: 'Keep your home comforts running during a blackout. AC units, kitchen appliances and power tools are all accessible with DELTA Pro. Use a single unit to power up to 4500W¹ of appliances. ',
        bgImgs: '/test/sImage5.png',
    };
    const TextOnItem5 = {
        title: 'Interior / Exterior Design',
        synopsis: 'Power pretty much anything',
        desc: 'Keep your home comforts running during a blackout. AC units, kitchen appliances and power tools are all accessible with DELTA Pro. ',
        bgImgs: '/test/sImage6.png',
        arr: [
            { num: '3.6', eum: 'kWh', desc: 'Expandable Capacity' },
            { num: '25', eum: 'kWh', desc: 'Expandable Capacity ' },
        ],
    };
    const TextOnItem6 = {
        title: 'Interior / Exterior Design',
        synopsis: 'Power pretty much anything',
        desc: 'Keep your home comforts running during a blackout. AC units, kitchen appliances and power tools are all accessible with DELTA Pro. ',
        bgImgs: '/test/sImage7.png',
        arr: [
            { num: '3.6', eum: 'kWh', desc: 'Expandable Capacity' },
            { num: '25', eum: 'kWh', desc: 'Expandable Capacity ' },
        ],
    };
    const textWithImgItem3 = {
        title: 'Interior / Exterior Design',
        synopsis: 'Power pretty much anything',
        desc: 'Keep your home comforts running during a blackout. AC units, kitchen appliances and power tools are all accessible with DELTA Pro. Use a single unit to power up to 4500W¹ of appliances. Need even more power? ',
        img_url: '/test/sImage8.png',
    };
    const textWithImgItem4 = {
        title: 'Interior / Exterior Design',
        synopsis: 'Power pretty much anything',
        desc: 'Keep your home comforts running during a blackout. AC units, kitchen appliances and power tools are all accessible with DELTA Pro. Use a single unit to power up to 4500W¹ of appliances. Need even more power? ',
        img_url: '/test/sImage8.png',
    };
    const textWithImgItem5 = {
        title: 'Interior / Exterior Design',
        synopsis: 'Power pretty much anything',
        desc: 'Keep your home comforts running during a blackout. AC units, kitchen appliances and power tools are all accessible with DELTA Pro. ',
        img_url: '/test/sImage8.png',
        arr: [
            { num: '3.6', eum: 'kWh', desc: 'Expandable Capacity' },
            { num: '25', eum: 'kWh', desc: 'Expandable Capacity ' },
        ],
    };
    const textWithImgItem6 = {
        title: 'Interior / Exterior Design',
        synopsis: 'Power pretty much anything',
        desc: 'Keep your home comforts running during a blackout. AC units, kitchen appliances and power tools are all accessible with DELTA Pro. ',
        img_url: '/test/sImage8.png',
        arr: [
            { num: '3.6', eum: 'kWh', desc: 'Expandable Capacity' },
            { num: '25', eum: 'kWh', desc: 'Expandable Capacity ' },
        ],
    };
    const TextOnItem7 = {
        title: 'Interior / Exterior Design',
        synopsis: 'Power pretty much anything',
        desc: 'Keep your home comforts running during a blackout. AC units, kitchen appliances and power tools are all accessible with DELTA Pro. Use a single unit to power up to 4500W¹ of appliances. Need even more power? ',
        bgImgs: '/test/sImage9.png',
    };
    const TextOnItem8 = {
        title: 'Interior / Exterior Design',
        synopsis: 'Power pretty much anything',
        desc: 'Keep your home comforts running during a blackout. AC units, kitchen appliances and power tools are all accessible with DELTA Pro. Use a single unit to power up to 4500W¹ of appliances. Need even more power? ',
        bgImgs: '/test/sImage11.png',
    };
    const textWithImgItem7 = {
        title: 'Interior / Exterior Design',
        synopsis: 'Power pretty much anything',
        desc: 'Keep your home comforts running during a blackout. AC units, kitchen appliances and power tools are all accessible with DELTA Pro. Use a single unit to power up to 4500W¹ of appliances. Need even more power? ',
        img_url: '/test/sImage10.png',
    };
    const textWithImgItem8 = {
        title: 'Interior / Exterior Design',
        synopsis: 'Power pretty much anything',
        desc: 'Keep your home comforts running during a blackout. AC units, kitchen appliances and power tools are all accessible with DELTA Pro. Use a single unit to power up to 4500W¹ of appliances. Need even more power? ',
        img_url: '/test/sImage10.png',
    };
    const TextOnItem9 = {
        title: 'Interior / Exterior Design',
        synopsis: 'Power pretty much anything',
        desc: 'Keep your home comforts running during a blackout. AC units, kitchen appliances and power tools are all accessible with DELTA Pro. Use a single unit to power up to 4500W¹ of appliances.',
        bgImgs: '/test/sImage12.png',
    };
    const TextOnItem10 = {
        title: 'Interior / Exterior Design',
        synopsis: 'Power pretty much anything',
        desc: 'Keep your home comforts running during a blackout. AC units, kitchen appliances and power tools are all accessible with DELTA Pro. Use a single unit to power up to 4500W¹ of appliances. ',
        bgImgs: '/test/sImage13.png',
    };
    const TextOnItem11 = {
        title: 'Interior / Exterior Design',
        synopsis: 'Power pretty much anything',
        desc: 'Keep your home comforts running during a blackout. AC units, kitchen appliances and power tools are all accessible with DELTA Pro. ',
        bgImgs: '/test/sImage14.png',
        arr: [
            { num: '3.6', eum: 'kWh', desc: 'Expandable Capacity' },
            { num: '25', eum: 'kWh', desc: 'Expandable Capacity ' },
        ],
    };
    const TextOnItem12 = {
        title: 'Interior / Exterior Design',
        synopsis: 'Power pretty much anything',
        desc: 'Keep your home comforts running during a blackout. AC units, kitchen appliances and power tools are all accessible with DELTA Pro. ',
        bgImgs: '/test/sImage15.png',
        arr: [
            { num: '3.6', eum: 'kWh', desc: 'Expandable Capacity' },
            { num: '25', eum: 'kWh', desc: 'Expandable Capacity ' },
        ],
    };
    const textWithImgItem9 = {
        title: 'Interior / Exterior Design',
        synopsis: 'Power pretty much anything',
        desc: 'Keep your home comforts running during a blackout. AC units, kitchen appliances and power tools are all accessible with DELTA Pro. Use a single unit to power up to 4500W¹ of appliances. Need even more power? ',
        img_url: '/test/sImage8.png',
    };
    const textWithImgItem10 = {
        title: 'Interior / Exterior Design',
        synopsis: 'Power pretty much anything',
        desc: 'Keep your home comforts running during a blackout. AC units, kitchen appliances and power tools are all accessible with DELTA Pro. Use a single unit to power up to 4500W¹ of appliances. Need even more power? ',
        img_url: '/test/sImage8.png',
    };
    const textWithImgItem11 = {
        title: 'Interior / Exterior Design',
        synopsis: 'Power pretty much anything',
        desc: 'Keep your home comforts running during a blackout. AC units, kitchen appliances and power tools are all accessible with DELTA Pro. ',
        img_url: '/test/sImage8.png',
        arr: [
            { num: '3.6', eum: 'kWh', desc: 'Expandable Capacity' },
            { num: '25', eum: 'kWh', desc: 'Expandable Capacity ' },
        ],
    };
    const textWithImgItem12 = {
        title: 'Interior / Exterior Design',
        synopsis: 'Power pretty much anything',
        desc: 'Keep your home comforts running during a blackout. AC units, kitchen appliances and power tools are all accessible with DELTA Pro. ',
        img_url: '/test/sImage8.png',
        arr: [
            { num: '3.6', eum: 'kWh', desc: 'Expandable Capacity' },
            { num: '25', eum: 'kWh', desc: 'Expandable Capacity ' },
        ],
    };
    const swiper_items1 = {
        text: {
            title: 'Interior / Exterior Design',
            synopsis: 'Power pretty much anything',
            desc: 'Keep your home comforts running during a blackout. AC units, kitchen appliances and power tools are all accessible with DELTA Pro. Use a single unit to power up to 4500W¹ of appliances. Need even more power?',
        },
        imgs: [
            { id: 1, bgImage: '/img/house.png', path: '' },
            { id: 2, bgImage: '/img/house.png', path: '' },
            { id: 3, bgImage: '/img/house.png', path: '' },
        ],
    };
    const swiper_items2 = {
        imgs: [
            { id: 1, bgImage: '/img/house.png', path: '' },
            { id: 2, bgImage: '/img/house.png', path: '' },
            { id: 3, bgImage: '/img/house.png', path: '' },
        ],
    };

    const switchTabData = [
        {
            tab: 'EV station charging',
            subTab: 'DELTA Pro is compatible ',
            key: 'k1',
            videoUrl: '"/video/op.mp4"',
            imgUrl: '/img/house_big.jpg',
            textTitle: 'Power pretty much anything ',
            textDesc:
                'DELTA Pro is compatible with 90% of portable solar panels. And with a 1600W input, you can charge up in as fast as 2.8 hours. Integrate DELTA Pro with your home using the Smart Home Panel and use your rooftop panels to charge up too¹. ',
            textSupliment: '¹While the grid is on-line, supports panels up to 150V, 3000W, requires use of a dedicated accessory (sold separately). ',
            showVideo: false,
        },
        {
            tab: 'Solar charging',
            subTab: 'DELTA Pro is compatible ',
            key: 'k2',
            videoUrl: '"/video/op.mp4"',
            imgUrl: '/img/drone-air.jpg',
            textTitle: 'Power pretty much anything ',
            textDesc:
                'DELTA Pro is compatible with 90% of portable solar panels. And with a 1600W input, you can charge up in as fast as 2.8 hours. Integrate DELTA Pro with your home using the Smart Home Panel and use your rooftop panels to charge up too¹. ',
            textSupliment: '¹While the grid is on-line, supports panels up to 150V, 3000W, requires use of a dedicated accessory (sold separately). ',
            showVideo: false,
        },
        {
            tab: 'wind turbine',
            subTab: 'DELTA Pro is compatible ',
            key: 'k3',
            videoUrl: '"/video/op.mp4"',
            imgUrl: '/img/house_big.jpg',
            textTitle: 'Power pretty much anything ',
            textDesc:
                'DELTA Pro is compatible with 90% of portable solar panels. And with a 1600W input, you can charge up in as fast as 2.8 hours. Integrate DELTA Pro with your home using the Smart Home Panel and use your rooftop panels to charge up too¹. ',
            textSupliment: '¹While the grid is on-line, supports panels up to 150V, 3000W, requires use of a dedicated accessory (sold separately). ',
            showVideo: false,
        },
        {
            tab: 'wall charge',
            subTab: 'DELTA Pro is compatible ',
            key: 'k4',
            videoUrl: '"/video/op.mp4"',
            imgUrl: '/img/drone-air.jpg',
            textTitle: 'Power pretty much anything ',
            textDesc:
                'DELTA Pro is compatible with 90% of portable solar panels. And with a 1600W input, you can charge up in as fast as 2.8 hours. Integrate DELTA Pro with your home using the Smart Home Panel and use your rooftop panels to charge up too¹. ',
            textSupliment: '¹While the grid is on-line, supports panels up to 150V, 3000W, requires use of a dedicated accessory (sold separately). ',
            showVideo: false,
        },
    ];

    return (
        <PageLayout>
            <div className={`${css.uiboard}`}>
                <Tabs tabPosition={'left'} defaultActiveKey="k1" className="tabs">
                    <TabPane tab="更多产品(OtherProductModule)" key="k1">
                        <OtherProductModule
                            data={{
                                items: [{ titleText: 'EcoFlow' }, { titleText: 'DELTA DELTA Portable Power Station' }, { titleText: 'EcoFlow' }],
                            }}
                        />
                        <LineSpace height={100} background="#d8d8d8" />
                        <OtherProductModule
                            cssStyle={{
                                backColor: '#000',
                                navColor: '#fff',
                                itemStyle: { wrapperBackColor: '#121212', titleColor: '#ffffff' },
                            }}
                        />
                    </TabPane>
                    <TabPane tab="多卖点展示(MultiSellPointsModule)" key="k2">
                        <MultiSellPointsModule />
                    </TabPane>
                    <TabPane tab="文本模块(TextModule)" key="k3">
                        {/* 1. 白-左侧 */}
                        <TextModule data={{ text: 'Power pretty much anything' }} cssStyle={{ type: 'll' }} />
                        <LineSpace background="#c1c1c1" opacity={0.49} height={90} />
                        <TextModule data={{ text: 'Power pretty much anything' }} cssStyle={{ type: 'lm' }} />
                        <LineSpace background="#c1c1c1" opacity={0.49} height={90} />
                        <TextModule data={{ text: 'Power pretty much anything' }} cssStyle={{ type: 'ls' }} />
                        <LineSpace background="#c1c1c1" opacity={0.49} height={90} />
                        <TextModule />
                        <LineSpace background="#c1c1c1" opacity={0.49} height={90} />
                        <TextModule
                            data={{
                                text: 'Keep your home comforts running during a blackout. AC units, kitchen appliances and power tools are all accessible with DELTA Pro. Use a single unit to power up to 4500W¹ of appliances. Need even more power? Chain two units together to hit a record-breaking 7200W, 240V output².',
                            }}
                            cssStyle={{ type: 'sl' }}
                        />
                        <LineSpace background="#c1c1c1" opacity={0.49} height={90} />
                        <TextModule
                            data={{
                                text: 'Keep your home comforts running during a blackout. AC units, kitchen appliances and power tools are all accessible with DELTA Pro. Use a single unit to power up to 4500W¹ of appliances. Need even more power? Chain two units together to hit a record-breaking 7200W, 240V output².',
                            }}
                            cssStyle={{ type: 'sm' }}
                        />
                        <LineSpace background="#c1c1c1" opacity={0.49} height={90} />
                        <TextModule data={{ text: '* With X-Boost mode turned on.' }} cssStyle={{ type: 'ss' }} />
                        <TextModule
                            data={{
                                text: '* Requires use of the Double Voltage Hub or Smart Home Panel(both sold separately). ',
                            }}
                            cssStyle={{ type: 'ss' }}
                        />
                        <LineSpace background="#c1c1c1" opacity={0.49} height={90} />
                        {/* 2. 白-居中 */}
                        <TextModule data={{ text: 'Power pretty much anything' }} cssStyle={{ type: 'll', textAlign: 'center' }} />
                        <LineSpace background="#c1c1c1" opacity={0.49} height={90} />
                        <TextModule data={{ text: 'Power pretty much anything' }} cssStyle={{ type: 'lm', textAlign: 'center' }} />
                        <LineSpace background="#c1c1c1" opacity={0.49} height={90} />
                        <TextModule data={{ text: 'Power pretty much anything' }} cssStyle={{ type: 'ls', textAlign: 'center' }} />
                        <LineSpace background="#c1c1c1" opacity={0.49} height={90} />
                        <TextModule cssStyle={{ textAlign: 'center' }} />
                        <LineSpace background="#c1c1c1" opacity={0.49} height={90} />
                        <TextModule
                            data={{
                                text: 'Keep your home comforts running during a blackout. AC units, kitchen appliances and power tools are all accessible with DELTA Pro. Use a single unit to power up to 4500W¹ of appliances. Need even more power? Chain two units together to hit a record-breaking 7200W, 240V output².',
                            }}
                            cssStyle={{ type: 'sl', textAlign: 'center' }}
                        />
                        <LineSpace background="#c1c1c1" opacity={0.49} height={90} />
                        <TextModule
                            data={{
                                text: 'Keep your home comforts running during a blackout. AC units, kitchen appliances and power tools are all accessible with DELTA Pro. Use a single unit to power up to 4500W¹ of appliances. Need even more power? Chain two units together to hit a record-breaking 7200W, 240V output².',
                            }}
                            cssStyle={{ type: 'sm', textAlign: 'center' }}
                        />
                        <LineSpace background="#c1c1c1" opacity={0.49} height={90} />
                        <TextModule data={{ text: '* With X-Boost mode turned on.' }} cssStyle={{ type: 'ss', textAlign: 'center' }} />
                        <TextModule
                            data={{
                                text: '* Requires use of the Double Voltage Hub or Smart Home Panel(both sold separately). ',
                            }}
                            cssStyle={{ type: 'ss', textAlign: 'center' }}
                        />
                        <LineSpace background="#c1c1c1" opacity={0.49} height={90} />
                        {/* 3. 黑-左侧 */}
                        <TextModule data={{ text: 'Power pretty much anything' }} cssStyle={{ type: 'll', theme: 'black' }} />
                        <LineSpace background="#d8d8d8" opacity={0.29} height={90} />
                        <TextModule data={{ text: 'Power pretty much anything' }} cssStyle={{ type: 'lm', theme: 'black' }} />
                        <LineSpace background="#d8d8d8" opacity={0.29} height={90} />
                        <TextModule data={{ type: 'ls', text: 'Power pretty much anything' }} cssStyle={{ type: 'ls', theme: 'black' }} />
                        <LineSpace background="#d8d8d8" opacity={0.29} height={90} />
                        <TextModule cssStyle={{ theme: 'black' }} />
                        <LineSpace background="#d8d8d8" opacity={0.29} height={90} />
                        <TextModule
                            data={{
                                text: 'Keep your home comforts running during a blackout. AC units, kitchen appliances and power tools are all accessible with DELTA Pro. Use a single unit to power up to 4500W¹ of appliances. Need even more power? Chain two units together to hit a record-breaking 7200W, 240V output².',
                            }}
                            cssStyle={{ type: 'sl', theme: 'black' }}
                        />
                        <LineSpace background="#d8d8d8" opacity={0.29} height={90} />
                        <TextModule
                            data={{
                                text: 'Keep your home comforts running during a blackout. AC units, kitchen appliances and power tools are all accessible with DELTA Pro. Use a single unit to power up to 4500W¹ of appliances. Need even more power? Chain two units together to hit a record-breaking 7200W, 240V output².',
                            }}
                            cssStyle={{ type: 'sm', theme: 'black' }}
                        />
                        <LineSpace background="#d8d8d8" opacity={0.29} height={90} />
                        <TextModule data={{ text: '* With X-Boost mode turned on.' }} cssStyle={{ type: 'ss', theme: 'black' }} />
                        <TextModule
                            data={{
                                text: '* Requires use of the Double Voltage Hub or Smart Home Panel(both sold separately). ',
                            }}
                            cssStyle={{ type: 'ss', theme: 'black' }}
                        />
                        <LineSpace background="#d8d8d8" opacity={0.29} height={90} />
                        {/* 4. 黑-居中 */}
                        <TextModule data={{ text: 'Power pretty much anything' }} cssStyle={{ type: 'll', textAlign: 'center', theme: 'black' }} />
                        <LineSpace background="#d8d8d8" opacity={0.29} height={90} />
                        <TextModule data={{ text: 'Power pretty much anything' }} cssStyle={{ type: 'lm', textAlign: 'center', theme: 'black' }} />
                        <LineSpace background="#d8d8d8" opacity={0.29} height={90} />
                        <TextModule data={{ text: 'Power pretty much anything' }} cssStyle={{ type: 'ls', textAlign: 'center', theme: 'black' }} />
                        <LineSpace background="#d8d8d8" opacity={0.29} height={90} />
                        <TextModule cssStyle={{ textAlign: 'center', theme: 'black' }} />
                        <LineSpace background="#d8d8d8" opacity={0.29} height={90} />
                        <TextModule
                            data={{
                                text: 'Keep your home comforts running during a blackout. AC units, kitchen appliances and power tools are all accessible with DELTA Pro. Use a single unit to power up to 4500W¹ of appliances. Need even more power? Chain two units together to hit a record-breaking 7200W, 240V output².',
                            }}
                            cssStyle={{ type: 'sl', textAlign: 'center', theme: 'black' }}
                        />
                        <LineSpace background="#d8d8d8" opacity={0.29} height={90} />
                        <TextModule
                            data={{
                                text: 'Keep your home comforts running during a blackout. AC units, kitchen appliances and power tools are all accessible with DELTA Pro. Use a single unit to power up to 4500W¹ of appliances. Need even more power? Chain two units together to hit a record-breaking 7200W, 240V output².',
                            }}
                            cssStyle={{ type: 'sm', textAlign: 'center', theme: 'black' }}
                        />
                        <LineSpace background="#d8d8d8" opacity={0.29} height={90} />
                        <TextModule data={{ text: '* With X-Boost mode turned on.' }} cssStyle={{ type: 'ss', textAlign: 'center', theme: 'black' }} />
                        <TextModule
                            data={{
                                text: '* Requires use of the Double Voltage Hub or Smart Home Panel(both sold separately). ',
                            }}
                            cssStyle={{ type: 'ss', textAlign: 'center', theme: 'black' }}
                        />
                        <LineSpace background="#d8d8d8" opacity={0.29} height={90} />
                    </TabPane>
                    <TabPane tab="切换按钮(SwitchTabModule)" key="k4">
                        {/* 1. 白 */}
                        <SwitchTabModule />
                        <LineSpace background="#c1c1c1" opacity={0.49} height={250} border="1px solid #979797" />
                        <SwitchTabModule cssStyle={{ position: 'bottom' }} />
                        <LineSpace background="#c1c1c1" opacity={0.49} height={250} border="1px solid #979797" />
                        <SwitchTabModule cssStyle={{ position: 'left' }} />
                        <LineSpace background="#c1c1c1" opacity={0.49} height={250} border="1px solid #979797" />
                        <SwitchTabModule cssStyle={{ position: 'right' }} />
                        <LineSpace background="#c1c1c1" opacity={0.49} height={250} border="1px solid #979797" />
                        {/* 2. 黑 */}
                        <SwitchTabModule data={switchTabData} cssStyle={{ backColor: '#000' }} />
                        <LineSpace background="#d8d8d8" opacity={0.29} height={250} border="1px solid #979797" />
                        <SwitchTabModule data={switchTabData} cssStyle={{ backColor: '#000', position: 'bottom' }} />
                        <LineSpace background="#d8d8d8" opacity={0.29} height={250} border="1px solid #979797" />
                        <SwitchTabModule data={switchTabData} cssStyle={{ backColor: '#000', position: 'left' }} />
                        <LineSpace background="#d8d8d8" opacity={0.29} height={250} border="1px solid #979797" />
                        <SwitchTabModule data={switchTabData} cssStyle={{ backColor: '#000', position: 'right' }} />
                        <LineSpace background="#d8d8d8" opacity={0.29} height={250} border="1px solid #979797" />
                    </TabPane>
                    <TabPane tab="卡片式(CardModule)" key="k5">
                        <CardModule />
                        <LineSpace background="#c1c1c1" opacity={0.49} height={250} border="1px solid #979797" />
                        <CardModule
                            cssStyle={{ backColor: '#000' }}
                            data={{
                                items: [
                                    {
                                        title: 'Power your home for days',
                                        desc: 'DELTA Pro’s capacity starts at 3.6kWh. Enough for hours of heavy-duty use. ',
                                        url: '/img/card-battery-1_black.png',
                                    },
                                    {
                                        title: 'Power your home for days',
                                        desc: 'DELTA Pro’s capacity starts at 3.6kWh. Enough for hours of heavy-duty use. ',
                                        url: '/img/card-battery-2_black.png',
                                    },
                                ],
                            }}
                        />
                        <LineSpace background="#c1c1c1" opacity={0.49} height={250} border="1px solid #979797" />
                        <CardModule
                            data={{
                                type: 'textImage',
                                items: [
                                    { url: '/img/card-mountain-1.png', guide: 'other' },
                                    { url: '/img/card-mountain-2.png', guide: 'DELTA PRO' },
                                ],
                            }}
                        />
                        <LineSpace background="#c1c1c1" opacity={0.49} height={250} border="1px solid #979797" />
                        <CardModule
                            cssStyle={{ backColor: '#000' }}
                            data={{
                                type: 'textImage',
                                items: [
                                    { url: '/img/card-mountain-1.png', guide: 'other' },
                                    { url: '/img/card-mountain-2.png', guide: 'DELTA PRO' },
                                ],
                            }}
                        />
                        <LineSpace background="#c1c1c1" opacity={0.49} height={250} border="1px solid #979797" />
                        <CardModule
                            data={{
                                type: 'textImageSlide',
                                items: [
                                    {
                                        url: '/img/card-slide-1.png',
                                        title: 'Power your home for days',
                                    },
                                    {
                                        url: '/img/card-slide-2.png',
                                        title: 'Power your home for days',
                                    },
                                    {
                                        url: '/img/card-slide-3.png',
                                        title: 'Power your home for days',
                                    },
                                    {
                                        url: '/img/card-slide-4.png',
                                        title: 'Power your home for days',
                                    },
                                    {
                                        url: '/img/card-slide-1.png',
                                        title: 'Power your home for days',
                                    },
                                    {
                                        url: '/img/card-slide-2.png',
                                        title: 'Power your home for days',
                                    },
                                ],
                            }}
                        />
                        <LineSpace background="#c1c1c1" opacity={0.49} height={250} border="1px solid #979797" />
                        <CardModule
                            data={{
                                type: 'textImageSlide',
                                items: [
                                    {
                                        url: '/img/card-slide-1.png',
                                        title: 'Power your home for days',
                                    },
                                    {
                                        url: '/img/card-slide-2.png',
                                        title: 'Power your home for days',
                                    },
                                    {
                                        url: '/img/card-slide-3.png',
                                        title: 'Power your home for days',
                                    },
                                    {
                                        url: '/img/card-slide-4.png',
                                        title: 'Power your home for days',
                                    },
                                    {
                                        url: '/img/card-slide-1.png',
                                        title: 'Power your home for days',
                                    },
                                    {
                                        url: '/img/card-slide-2.png',
                                        title: 'Power your home for days',
                                    },
                                ],
                            }}
                            cssStyle={{ backColor: '#000' }}
                        />
                        <LineSpace background="#c1c1c1" opacity={0.49} height={250} border="1px solid #979797" />
                        <CardModule data={{ type: 'textTextLeft' }} />
                        <LineSpace background="#c1c1c1" opacity={0.49} height={250} border="1px solid #979797" />
                        <CardModule
                            data={{
                                type: 'textTextLeft',
                                singleImg: '/img/card-microapp_black.png',
                            }}
                            cssStyle={{ backColor: '#000' }}
                        />
                        <LineSpace background="#c1c1c1" opacity={0.49} height={250} border="1px solid #979797" />
                        <CardModule data={{ type: 'textTextRight' }} />
                        <LineSpace background="#c1c1c1" opacity={0.49} height={250} border="1px solid #979797" />
                        <CardModule
                            data={{
                                type: 'textTextRight',
                                singleImg: '/img/card-microapp_black.png',
                            }}
                            cssStyle={{ backColor: '#000' }}
                        />
                        <LineSpace background="#c1c1c1" opacity={0.49} height={250} border="1px solid #979797" />
                    </TabPane>
                    <TabPane tab="自定义轮播" key="k6">
                        <SwiperBanner cssStyle={{ config: { list: { imgHeight: 800 } } }} />
                        <LineSpace height={250} background="#c1c1c1" />
                        <SwiperBanner
                            cssStyle={{
                                type: 'full_image_with_text_top',
                                config: { list: { imgHeight: 800 } },
                            }}
                            data={{
                                items: [
                                    { img: '/img/banner_drone_big.jpg', desc: '' },
                                    { img: '/img/banner_hotel_big.jpg', desc: '' },
                                    { img: '/img/banner_drone_big.jpg', desc: '' },
                                    { img: '/img/banner_hotel_big.jpg', desc: '' },
                                ],
                            }}
                        />
                        <LineSpace height={250} background="#c1c1c1" />
                        <SwiperBanner
                            cssStyle={{
                                type: 'full_image_with_text_top',
                                backColor: '#000',
                                config: { list: { imgHeight: 800 } },
                            }}
                            data={{
                                items: [
                                    { img: '/img/banner_hotel_big.jpg', desc: '' },
                                    { img: '/img/banner_drone_big.jpg', desc: '' },
                                    { img: '/img/banner_hotel_big.jpg', desc: '' },
                                    { img: '/img/banner_drone_big.jpg', desc: '' },
                                ],
                            }}
                        />
                        <LineSpace height={250} background="#c1c1c1" />
                        <SwiperBanner
                            cssStyle={{
                                type: 'full_image_with_text_bottom',
                                config: { list: { imgHeight: 800 } },
                            }}
                            data={{
                                items: [
                                    { img: '/img/banner_drone_big.jpg', desc: '' },
                                    { img: '/img/banner_hotel_big.jpg', desc: '' },
                                    { img: '/img/banner_drone_big.jpg', desc: '' },
                                    { img: '/img/banner_hotel_big.jpg', desc: '' },
                                ],
                            }}
                        />
                        <LineSpace height={250} background="#c1c1c1" />
                        <SwiperBanner
                            cssStyle={{
                                type: 'full_image_with_text_bottom',
                                backColor: '#000',
                                config: { list: { imgHeight: 800 } },
                            }}
                            data={{
                                items: [
                                    { img: '/img/banner_hotel_big.jpg', desc: '' },
                                    { img: '/img/banner_drone_big.jpg', desc: '' },
                                    { img: '/img/banner_hotel_big.jpg', desc: '' },
                                    { img: '/img/banner_drone_big.jpg', desc: '' },
                                ],
                            }}
                        />
                        <LineSpace height={250} background="#c1c1c1" />
                        <SwiperBanner
                            cssStyle={{ type: 'container_image_with_text_bottom' }}
                            data={{
                                items: [
                                    { img: '/img/productDetails/river/7_camera.jpg', desc: '' },
                                    { img: '/img/productDetails/river/7_camera.jpg', desc: '' },
                                    { img: '/img/productDetails/river/7_camera.jpg', desc: '' },
                                ],
                            }}
                        />
                        <LineSpace height={250} background="#c1c1c1" />
                        <SwiperBanner
                            cssStyle={{
                                type: 'container_image_with_text_bottom',
                                backColor: '#000',
                            }}
                            data={{
                                items: [
                                    { img: '/img/productDetails/river/7_camera.jpg', desc: '' },
                                    { img: '/img/productDetails/river/7_camera.jpg', desc: '' },
                                    { img: '/img/productDetails/river/7_camera.jpg', desc: '' },
                                ],
                            }}
                        />
                        <LineSpace height={250} background="#c1c1c1" />
                        <SwiperBanner
                            cssStyle={{ type: 'container_image_with_text_top' }}
                            data={{
                                items: [
                                    { img: '/img/productDetails/river/7_camera.jpg', desc: '' },
                                    { img: '/img/productDetails/river/7_camera.jpg', desc: '' },
                                    { img: '/img/productDetails/river/7_camera.jpg', desc: '' },
                                ],
                            }}
                        />
                        <LineSpace height={250} background="#c1c1c1" />
                        <SwiperBanner
                            cssStyle={{ type: 'container_image_with_text_top', backColor: '#000' }}
                            data={{
                                items: [
                                    { img: '/img/productDetails/river/7_camera.jpg', desc: '' },
                                    { img: '/img/productDetails/river/7_camera.jpg', desc: '' },
                                    { img: '/img/productDetails/river/7_camera.jpg', desc: '' },
                                ],
                            }}
                        />
                        <LineSpace height={250} background="#c1c1c1" />
                        <SwiperBanner
                            cssStyle={{ type: 'center_image_with_text_top' }}
                            data={{
                                items: [
                                    { img: '/img/banner_phone_big.jpg', desc: '' },
                                    { img: '/img/banner_home_big.jpg', desc: '' },
                                    { img: '/img/banner_phone_big.jpg', desc: '' },
                                    { img: '/img/banner_home_big.jpg', desc: '' },
                                ],
                            }}
                        />
                        <LineSpace height={250} background="#c1c1c1" />
                        <SwiperBanner
                            cssStyle={{ type: 'center_image_with_text_top', backColor: '#000' }}
                            data={{
                                items: [
                                    { img: '/img/banner_home_big.jpg', desc: '' },
                                    { img: '/img/banner_phone_big.jpg', desc: '' },
                                    { img: '/img/banner_home_big.jpg', desc: '' },
                                    { img: '/img/banner_phone_big.jpg', desc: '' },
                                ],
                            }}
                        />
                        <LineSpace height={250} background="#c1c1c1" />
                        <SwiperBanner
                            cssStyle={{ type: 'center_image_with_text_bottom' }}
                            data={{
                                items: [
                                    { img: '/img/banner_phone_big.jpg', desc: '' },
                                    { img: '/img/banner_home_big.jpg', desc: '' },
                                    { img: '/img/banner_phone_big.jpg', desc: '' },
                                    { img: '/img/banner_home_big.jpg', desc: '' },
                                ],
                            }}
                        />
                        <LineSpace height={250} background="#c1c1c1" />
                        <SwiperBanner
                            cssStyle={{ type: 'center_image_with_text_bottom', backColor: '#000' }}
                            data={{
                                items: [
                                    { img: '/img/banner_home_big.jpg', desc: '' },
                                    { img: '/img/banner_phone_big.jpg', desc: '' },
                                    { img: '/img/banner_home_big.jpg', desc: '' },
                                    { img: '/img/banner_phone_big.jpg', desc: '' },
                                ],
                            }}
                        />
                        <LineSpace height={250} background="#c1c1c1" />
                    </TabPane>
                    <TabPane tab="自定义slider" key="k7">
                        <CardSliderModule />
                    </TabPane>
                    {/* <TabPane tab="solar panel()" key="k8">
                        <SolarPanel />
                    </TabPane> */}
                    <TabPane tab="详情页首屏" key="a1">
                        <BannerModule data={banneritem2} config={{ position: 'left', theme: 'black' }} />
                        <LineSpace height="xxl" background="#fff" />
                        <BannerModule data={banneritem3} config={{ position: 'top', theme: 'black' }} />
                        <LineSpace height="xxl" background="#fff" />
                        <BannerModule data={banneritem4} config={{ position: 'bottom', theme: 'black' }} />
                        <LineSpace height="xxl" background="#fff" />
                        <BannerModule data={banneritem5} config={{ position: 'left', theme: 'black', isShowVideo: true }} />
                        <LineSpace height="xxl" background="#fff" />
                        <BannerModule data={banneritem6} config={{ position: 'top', theme: 'black', isShowVideo: true }} />
                        <LineSpace height="xxl" background="#fff" />
                        <BannerModule data={banneritem7} config={{ position: 'bottom', theme: 'black', isShowVideo: true }} />
                        <LineSpace height="xxl" background="#fff" />
                        <BannerModule data={banneritem8} config={{ position: 'left', theme: 'white' }} />
                        <LineSpace height="xxl" background="#fff" />
                        <BannerModule data={banneritem9} config={{ position: 'top', theme: 'white' }} />
                        <LineSpace height="xxl" background="#fff" />
                        <BannerModule data={banneritem10} config={{ position: 'bottom', theme: 'white' }} />
                        <LineSpace height="xxl" background="#fff" />
                        <BannerModule data={banneritem11} config={{ position: 'left', theme: 'white', isShowVideo: true }} />
                        <LineSpace height="xxl" background="#fff" />
                        <BannerModule data={banneritem12} config={{ position: 'top', theme: 'white', isShowVideo: true }} />
                        <LineSpace height="xxl" background="#fff" />
                        <BannerModule data={banneritem13} config={{ position: 'bottom', theme: 'white', isShowVideo: true }} />
                    </TabPane>
                    <TabPane tab="单图（TextOnImage&TextWithImage）" key="a2">
                        <TextOnImage
                            data={TextOnItem1}
                            config={{
                                position: 'top',
                                titleFontSize: 32,
                                titleColor: '#03060b',
                                synopsisColor: '#03060b',
                                descColor: '#666',
                            }}
                        />
                        <LineSpace height={110} background="#000" />
                        <TextOnImage
                            data={TextOnItem2}
                            config={{
                                position: 'bottom',
                                titleFontSize: 32,
                                titleColor: '#03060b',
                                synopsisColor: '#03060b',
                                descColor: '#666',
                            }}
                        />
                        <LineSpace height={120} background="#000" />
                        <TextWithImage
                            data={textWithImgItem1}
                            config={{
                                position: 'top',
                                titleFontSize: 32,
                                titleColor: '#03060b',
                                synopsisColor: '#03060b',
                                descColor: '#666',
                                imgHeight: '1080px',
                                imgWidth: '100%',
                            }}
                        />
                        <LineSpace height={120} background="#000" />
                        <TextWithImage
                            config={{
                                position: 'bottom',
                                titleColor: '#03060b',
                                titleFontSize: 32,
                                synopsisColor: '#03060b',
                                descColor: '#666',
                                imgHeight: '1080px',
                                imgWidth: '100%',
                            }}
                            data={textWithImgItem2}
                        />
                        <LineSpace height={120} background="#000" />
                        <TextOnImage
                            data={TextOnItem3}
                            config={{
                                position: 'left',
                                titleColor: '#03060b',
                                synopsisColor: '#03060b',
                                descColor: '#666',
                            }}
                        />
                        <LineSpace height={110} background="#000" />
                        <TextOnImage
                            data={TextOnItem4}
                            config={{
                                position: 'right',
                                titleColor: '#03060b',
                                synopsisColor: '#03060b',
                                descColor: '#666',
                            }}
                        />
                        <LineSpace height={120} background="#000" />
                        <TextOnImage
                            data={TextOnItem5}
                            config={{
                                position: 'left',
                                titleColor: '#03060b',
                                synopsisColor: '#03060b',
                                descColor: '#666',
                                imgHeight: '900px',
                            }}
                        />
                        <LineSpace height={110} background="#000" />
                        <TextOnImage
                            data={TextOnItem6}
                            config={{
                                position: 'right',
                                titleColor: '#03060b',
                                synopsisColor: '#03060b',
                                descColor: '#666',
                                imgHeight: '900px',
                            }}
                        />
                        <LineSpace height={120} background="#000" />
                        <TextWithImage
                            data={textWithImgItem3}
                            config={{
                                position: 'left',
                                titleColor: '#03060b',
                                synopsisColor: '#03060b',
                                descColor: '#666',
                            }}
                        />
                        <LineSpace height={120} background="#000" />
                        <TextWithImage
                            config={{
                                position: 'right',
                                titleColor: '#03060b',
                                synopsisColor: '#03060b',
                                descColor: '#666',
                            }}
                            data={textWithImgItem4}
                        />
                        <LineSpace height={120} background="#000" />
                        <TextWithImage
                            data={textWithImgItem5}
                            config={{
                                position: 'left',
                                titleColor: '#03060b',
                                synopsisColor: '#03060b',
                                descColor: '#666',
                            }}
                        />
                        <LineSpace height={120} background="#000" />
                        <TextWithImage
                            config={{
                                position: 'right',
                                titleColor: '#03060b',
                                synopsisColor: '#03060b',
                                descColor: '#666',
                            }}
                            data={textWithImgItem6}
                        />
                        <LineSpace height={120} background="#000" />

                        <div style={{ backgroundColor: '#000', width: '100%' }}>
                            <TextOnImage
                                data={TextOnItem7}
                                config={{
                                    position: 'top',
                                    titleFontSize: 32,
                                    titleColor: '#ededed',
                                    synopsisColor: '#fff',
                                    descColor: '#f6f6f8',
                                }}
                            />
                            <LineSpace height={110} background="#fff" />

                            <TextWithImage
                                data={textWithImgItem7}
                                config={{
                                    position: 'top',
                                    titleFontSize: 32,
                                    titleColor: '#ededed',
                                    synopsisColor: '#fff',
                                    descColor: '#f6f6f8',
                                    imgHeight: '1080px',
                                    imgWidth: '100%',
                                }}
                            />
                            <LineSpace height={120} background="#fff" />
                            <TextWithImage
                                config={{
                                    position: 'bottom',
                                    titleColor: '#ededed',
                                    titleFontSize: 32,
                                    synopsisColor: '#fff',
                                    descColor: '#f6f6f8',
                                    imgHeight: '1080px',
                                    imgWidth: '100%',
                                }}
                                data={textWithImgItem8}
                            />
                            <LineSpace height={120} background="#fff" />
                            <TextOnImage
                                data={TextOnItem8}
                                config={{
                                    position: 'bottom',
                                    titleColor: '#ededed',
                                    synopsisColor: '#fff',
                                    titleFontSize: 32,
                                    descColor: '#f6f6f8',
                                }}
                            />
                            <LineSpace height={120} background="#fff" />
                            <TextOnImage
                                data={TextOnItem9}
                                config={{
                                    position: 'left',
                                    titleColor: '#ededed',
                                    synopsisColor: '#fff',
                                    descColor: '#999',
                                }}
                            />
                            <LineSpace height={110} background="#fff" />
                            <TextOnImage
                                data={TextOnItem10}
                                config={{
                                    position: 'right',
                                    titleColor: '#ededed',
                                    synopsisColor: '#fff',
                                    descColor: '#999',
                                }}
                            />
                            <LineSpace height={120} background="#fff" />
                            <TextOnImage
                                data={TextOnItem11}
                                config={{
                                    position: 'left',
                                    itemsColor: '#fff',
                                    itemsDescColor: '#919191',
                                    titleColor: '#ededed',
                                    synopsisColor: '#fff',
                                    descColor: '#999',
                                    imgHeight: '900px',
                                }}
                            />
                            <LineSpace height={110} background="#fff" />
                            <TextOnImage
                                data={TextOnItem12}
                                config={{
                                    position: 'right',
                                    itemsColor: '#fff',
                                    itemsDescColor: '#919191',
                                    titleColor: '#ededed',
                                    synopsisColor: '#fff',
                                    descColor: '#999',
                                    imgHeight: '900px',
                                }}
                            />
                            <LineSpace height={120} background="#fff" />
                            <TextWithImage
                                data={textWithImgItem9}
                                config={{
                                    position: 'left',
                                    titleColor: '#ededed',
                                    synopsisColor: '#fff',
                                    descColor: '#999',
                                }}
                            />
                            <LineSpace height={120} background="#fff" />
                            <TextWithImage
                                config={{
                                    position: 'right',
                                    titleColor: '#ededed',
                                    synopsisColor: '#fff',
                                    descColor: '#999',
                                }}
                                data={textWithImgItem10}
                            />
                            <LineSpace height={120} background="#fff" />
                            <TextWithImage
                                data={textWithImgItem11}
                                config={{
                                    isShowVideo: true,
                                    position: 'left',
                                    itemsColor: '#fff',
                                    itemsDescColor: '#919191',
                                    titleColor: '#ededed',
                                    synopsisColor: '#fff',
                                    descColor: '#999',
                                }}
                            />
                            <LineSpace height={120} background="#fff" />
                            <TextWithImage
                                config={{
                                    position: 'right',
                                    titleColor: '#ededed',
                                    isShowVideo: true,
                                    itemsColor: '#fff',
                                    itemsDescColor: '#919191',
                                    synopsisColor: '#fff',
                                    descColor: '#999',
                                }}
                                data={textWithImgItem12}
                            />
                        </div>
                    </TabPane>

                    <TabPane tab="视频(VideoModule)" key="a4">
                        <VideoModule config={{ bgColor: '#fff', fullScreen: true }} />
                        <LineSpace height="xxl" background="#fff" />
                        <VideoModule config={{ bgColor: '#fff' }} />
                    </TabPane>
                </Tabs>
            </div>
        </PageLayout>
    );
}

export function getServerSideProps() {
    return {
        props: {},
    };
}
